import(/* webpackMode: "eager", webpackExports: ["ArticleListSection"] */ "/app/apps/todoist-landing-pages/app/[locale]/productivity-methods/components/article-list-section/article-list-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/productivity-methods/components/intro-section/intro-section.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/productivity-methods/components/prefooter/prefooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RichTextSubscribe"] */ "/app/apps/todoist-landing-pages/components/blog-posts/rich-text-subscribe/rich-text-subscribe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainPageHeader"] */ "/app/apps/todoist-landing-pages/components/main-page-header/main-page-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/packages/marketist/dist/components/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/packages/marketist/dist/components/image/image.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/packages/marketist/dist/components/Link/Link.js");
